import { render, staticRenderFns } from "./AboutExistingChildSupport.vue?vue&type=template&id=00c23dfa"
import script from "./AboutExistingChildSupport.vue?vue&type=script&lang=ts"
export * from "./AboutExistingChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports